export default class EmergencyDetailModel {
  public id: number
  public emergencyDetailId: number
  public typeId: number
  public description: string
  public tradeId: number | null
  public orderBy: number
}
